import PagesTabs from "./tabs";
import { NETWORK_SERVICES_CONSTANTS } from "@/components/header/header.constants";

const NetworkServicesTabs = () => {
  return <PagesTabs props={NETWORK_SERVICES_CONSTANTS} />;
};

export default NetworkServicesTabs;
